const getActiveSidebar = state => state.activeSidebar;


export default {
  getActiveSidebar,
};



// WEBPACK FOOTER //
// ./src/store/modules/home/getters.js